<template>
  <div></div>
</template>

<script>
import crmService from '../services/crmService'
export default {
  name: 'Verify',
  created() {
    this.verifyMail()
  },
  methods: {
    verifyMail() {
      crmService
        .verifyEmail(decodeURIComponent(window.location.search))
        .then(res => {
          crmService
            .verifyEmail1(res.data, decodeURIComponent(window.location.search))
            .then(() => {
              this.$router.push({ name: 'login' })
              this.$message('Twój email został zweryfikowany')
            })
        })
    },
  },
}
</script>

<style scoped></style>
